import {useImageOverlayMapLayerProvider} from "base/component/geo";
import {createImageOverlayLayerLegend, useImageOverlayLayerObject} from "base/map";
import SquareIcon from "@mui/icons-material/Square";
const layersBounds = [
    [35.059144518, -13.868055734],
    [65.920960866, 28.074501814],
];

export function useMaritimetransportgvaMapProvider(config) {
    const layer = useImageOverlayLayerObject({
        opacity: 0.5,
        imageUrl: "/images/Maritimetransportgva.png",
        imageBounds: layersBounds,
        legend: createImageOverlayLayerLegend({
            layerName: "Maritime transport GVA",
            layerType: "rst",
            legendItems: [
                {
                    label: "(€ million)",
                    color: "white",
                    icon: null,
                },
                {
                    label: "<= 0,0001",
                    color: "#def5e5",
                    icon: <SquareIcon sx={{fontSize: "0.8rem"}} />,
                },
                {
                    label: "0,0001 - 0,0004",
                    color: "#62cfac",
                    icon: <SquareIcon sx={{fontSize: "0.8rem"}} />,
                },
                {
                    label: "0,0004 - 0,0009",
                    color: "#3498a9",
                    icon: <SquareIcon sx={{fontSize: "0.8rem"}} />,
                },
                {
                    label: "0,0009 - 0,0023",
                    color: "#395d9c",
                    icon: <SquareIcon sx={{fontSize: "0.8rem"}} />,
                },
                {
                    label: "0,0023 - 0,0075",
                    color: "#382a54",
                    icon: <SquareIcon sx={{fontSize: "0.8rem"}} />,
                },
                {
                    label: "> 0,0075",
                    color: "#0b0405",
                    icon: <SquareIcon sx={{fontSize: "0.8rem"}} />,
                },
            ],
        }),
    });
    const [provider] = useImageOverlayMapLayerProvider(layer, config);

    return provider;
}
